module.exports = "{{ prefix }}{{ page | number: places }}{{ suffix }}\n{{ splitter }}\n{{ prefix }}{{ total | number: places }}{{ suffix }}"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/dtFooter/view.html
// module id = 932
// module chunks = 0